var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSupported)?_c('div',{staticClass:"vue-audio-recorder",class:{
      'active': _vm.isRecording,
      'paused': _vm.isPaused,
      'disabled': _vm.disabled
    },on:{"click":_vm.onClick}},[_c('span')]):_vm._e(),(!_vm.disabled)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.hint))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }